export default {
  title: 'Yrityskatsaus',
  description: 'Tervetuloa takaisin, {{name}}! Tässä on markkinointisi tilanne.',
};
